import {HttpParams} from '@angular/common/http';

export class helpers {
  static ConvertToNumber(value: string | number) {
    if (!value || typeof value === 'object') return 0;

    if (typeof value === 'number') return value;

    let newValue = value.replace(/[$,%]/g, '');
    let numValue = parseFloat(newValue);

    return numValue;
  }

  public static isEmptyValues(value: any) {
    return (
      value === undefined ||
      value === null ||
      Number.isNaN(value) ||
      (typeof value === 'object' && !(value instanceof Date) && Object.keys(value).length === 0) ||
      (typeof value === 'string' && value.trim().length === 0)
    );
  }

  static getValueForField(item: object, field?: string) {
    if (!field) {
      return undefined;
    }
    let fields = field.split('.');
    let possibleValue = fields.reduce((obj: any, i, curr, array) => {
      if (obj == undefined) {
        array.splice(1);
        return undefined;
      }
      return obj[i];
    }, item);
    return possibleValue;
  }

  public static toHttpParam(queryParams: any): HttpParams {
    let params = new HttpParams();
    if (!queryParams) return params;

    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] && typeof queryParams[key] === 'string') {
        let values = queryParams[key].split(',');

        if (values.length > 1 && Array.isArray(values))
          values.forEach((paramValue) => (params = params.append(key, paramValue)));
        else params = params.append(key, queryParams[key]);
      } else if (queryParams[key]) {
        params = params.append(key, queryParams[key]);
      }
    });

    return params;
  }

  public static hasLowerCase(str: string) {
    return /[a-z]/.test(str);
  }

  public static hasUpperCase(str: string) {
    return /[A-Z]/.test(str);
  }

  public static hasNumber(str: string) {
    return /\d/.test(str);
  }

  public static hasSpecialCharacter(str: string) {
    return /[^a-zA-Z0-9\s]/.test(str);
  }

  public static transformCamelCase(input: string, separator: string = '-') {
    return input.replace(/([a-z])([A-Z])/g, `$1${separator}$2`).toLowerCase();
  }

  public static deleteUrlParam(url: URL, param: string, pushHistory: boolean = false) {
    if (!url) {
      url = new URL(window.location.href);
    }
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      if (pushHistory) {
        window.history.pushState(null, '', url.toString());
      } else {
        window.history.replaceState(null, '', url.toString());
      }
    }
  }

  public static updateUrlParam(url: URL, param: string, newValue: string, clearHash: boolean = false, pushHistory: boolean = false) {
    if (!url) {
      url = new URL(window.location.href);
    }
    if (url.searchParams.has(param)) {
      url.searchParams.set(param, newValue);
    } else {
      url.searchParams.append(param, newValue);
    }
    if (clearHash) {
      url.hash = '';
    }
    if (pushHistory) {
      window.history.pushState(null, '', url.toString());
    } else {
      window.history.replaceState(null, '', url.toString());
    }
  }

  public static dateToEasternTimezone(date: Date) {
    return new Date(date.toLocaleDateString('en-US', {timeZone: 'America/New_York'}));
  }

  public static isTodayInRange(start: Date, end: Date): boolean {
    const today = new Date(helpers.dateToEasternTimezone(new Date())).getTime();
    const startTime = new Date(helpers.dateToEasternTimezone(new Date(start))).getTime();
    const endTime = new Date(helpers.dateToEasternTimezone(new Date(end))).getTime();

    return today >= startTime && today <= endTime;
  }
}